export const ANNOUNCEMENTS_RESET_STATE = 'ANNOUNCEMENTS_RESET_STATE';
export const ANNOUNCEMENTS_CURRENT_ITEM = 'ANNOUNCEMENTS_CURRENT_ITEM';

export const ANNOUNCEMENTS_REQUEST_LOADING = 'ANNOUNCEMENTS_REQUEST_LOADING';
export const ANNOUNCEMENTS_REQUEST_SUCCESS = 'ANNOUNCEMENTS_REQUEST_SUCCESS';
export const ANNOUNCEMENTS_REQUEST_FAILED = 'ANNOUNCEMENTS_REQUEST_FAILED';

export const ANNOUNCEMENTS_CURRENT_ACTION = 'ANNOUNCEMENTS_CURRENT_ACTION';
export const ANNOUNCEMENTS_RESET_ACTION = 'ANNOUNCEMENTS_RESET_ACTION';